import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { mergeClasses } from '@frontend/design-system';

type Props = PropsWithChildren<{
  className?: string;
}>;

export const ContentComposerHeader = ({ children, className }: Props) => {
  return (
    <header
      className={mergeClasses('content-composer-header', className)}
      css={{
        alignItems: 'center',
        background: theme.colors.white,
        borderBottom: `solid 1px ${theme.colors.neutral20}`,
        display: 'grid',
        gridArea: 'header',
      }}
    >
      {children}
    </header>
  );
};
